import { render, staticRenderFns } from "./CorporativeDetails.vue?vue&type=template&id=4eff82b9&scoped=true"
import script from "./CorporativeDetails.vue?vue&type=script&lang=js"
export * from "./CorporativeDetails.vue?vue&type=script&lang=js"
import style0 from "./CorporativeDetails.vue?vue&type=style&index=0&id=4eff82b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eff82b9",
  null
  
)

export default component.exports